export default {
  enUs: 'en-us',
  enUk: 'en-uk',
  hr: 'hr',
  pl: 'pl',
};
